import { render, staticRenderFns } from "./PuzzleDetail.vue?vue&type=template&id=41981e8b&scoped=true&"
import script from "./PuzzleDetail.vue?vue&type=script&lang=js&"
export * from "./PuzzleDetail.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleDetail.vue?vue&type=style&index=0&id=41981e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41981e8b",
  null
  
)

export default component.exports